module.exports = __webpack_public_path__ + "img/深海精华.d112c846.jpg";